export default function objIsEmpty (obj) {
	for (var key in obj) {
		if(obj.hasOwnProperty(key)) {
			return false
		}
	}
	return true
}



// WEBPACK FOOTER //
// ./src/utils/objIsEmpty.js